<template>
  <div style="background-color:#fff;height: 100%;">
    <van-sticky :offset-top="0 " >
      <mini_head_top> </mini_head_top>
    </van-sticky>
    <van-row  type="flex"  justify="space-between" style="margin-left :10px; padding: auto; margin-top:10px;text-align: left">
      <van-col :span= '20'>
        <span style="margin-left: 0px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:16px; font-weight:700">{{ viewQbOneDetail.moduleName }}知识题库</span>
      </van-col>
      <van-col >
        <el-link :span= '4' style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-col>        
    </van-row >
    <div class = "w-e-text-container"  style="height:calc( 100vh - 150px ); overflow: auto;">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="" name="1">
        <template #title>
           <el-tag size ="mini" type="success">查看学习进度 </el-tag>
        </template>
        <div style=" overflow:auto; text-align: left;background-color: ghostwhite ">
        <div  class="clearfix" style="margin-left:10px">
          <el-tag size ="mini">
            {{ viewQbOneDetail.moduleName }}
          </el-tag>
          <span>
            一共{{ viewQbOneDetail.totalCount }}题
          </span>
        </div>
        <div style="margin-top: 10px;text-align: center;">
          <el-progress type="circle" :format="funcAnswered" :percentage="viewQbOneDetail.learnPer" :width="70"></el-progress>
          <el-progress type="circle" :format="funcOk" :percentage="viewQbOneDetail.learnOkPer" :width="70" style="margin-left:20px"></el-progress>
        </div>     
        <div v-for = "(item,index) in viewQbOneDetail.qtList" :key="index" style="margin-top:5px;margin-left: 10px;">
          <el-tag size ="mini"> {{item.answerCheckType}}</el-tag>
            <span style="margin-top : 5px">一共:{{item.count}}题 </span>
            <span style="margin-top : 5px">已学:{{item.learnCount}}题 </span>
        </div>
      </div>
    </van-collapse-item>
    </van-collapse>
      <div style="text-align:left ; margin:10px; overflow:auto;">
        <div slot="header" class="clearfix">
          <el-tag size="mini" type="warning">{{ qbView.uniqNo }}</el-tag>
          <el-tag  size="mini" style ="margin-left: 10px;">{{ qbView.moduleName }}</el-tag>
          <el-tag size="mini" type="success">{{  qbView.answerCheckType }}</el-tag>
          <el-tag  size="mini" :type=" qbView.selected ? 'success' : 'warning'">{{  qbView.selected ? '已作答':'未作答' }}</el-tag>
          <el-button  type="primary"  v-if ="qbView.selected"   style="padding:2px;" @click="recordOneSchedule()" size = "small" icon="">设置书签 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
          <el-button  type="danger"  v-if ="qbView.selected && !qbView.resultOk"   style="el-icon--right" @click="recordErrorQb()" size = "small" icon="">加入错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag size="mini" type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0 "> 
          <el-tag size="mini" type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px;"
              :src="item.url"
              :fit="fit">
            </el-image>
          </el-badge>
        </div>
        <div style ="margin-top: 10px;">
          <el-row>
            <el-col :span="2">
              <el-tag size="mini" type="warning">选项</el-tag>
            </el-col>
            <el-col :span="22">
              <el-checkbox-group v-model="qbView.checkedOptList" >
                <el-checkbox style ="margin-left: 10px;word-break: break-all;display: block;overflow:
                hidden; text-overflow: ellipsis;white-space: normal"
                :disabled = "qbView.selected" v-for="(opt , index ) in qbView.optionValueArr" 
                :label="String.fromCharCode(65 + index)" :key="opt">
                    {{opt}}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </div>
        <div style ="margin-top: 10px;" v-if ="qbView.selected" >
          <el-tag  size="mini" type="warning">我的答案</el-tag>
          <span style ="margin-left: 10px;">{{qbView.learnAnswer }}</span>
          <el-button  size="mini"  :type="qbView.resultOk ? 'success':'danger'"
            :icon="qbView.resultOk ? 'el-icon-check': 'el-icon-close'" circle></el-button>
        </div>
        <div style ="margin-top: 10px;">
          <el-tag size="mini" type="warning">操作</el-tag>
          <el-button v-if ="!qbView.selected"   style ="margin-left:10px;" type="primary"   @click="submitAnswer()"  size = "small">提交答案<i class="el-icon-upload el-icon--right"></i></el-button>
          <el-button  type="primary"  style="padding:2px;"   v-if ="qbView.selected"  size = "small" @click = "seeAnswer()" icon="el-icon-search">查看答案</el-button>
          <el-button  type="primary"  style="padding:2px;"  size = "small" icon="el-icon-arrow-left"  @click = "learnNextQb2(false)" >上一题</el-button>
          <el-button  type="primary" style="padding:1px;"  size = "small"  @click = "learnNextQb2(true)" icon="">下一题 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
          <el-button  type="primary"    style="padding:2px;"  size = "small"  @click = "leanNextUndoQb()" icon="">未学习 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div >
        <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer" >
          <el-tag size="mini" type="warning">答案</el-tag>
          <span style ="margin-left: 10px;" > {{qbView.answer }}</span>
        </div >
        <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer">
          <el-tag  type="warning"  >解析</el-tag>
          <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
        </div>
      </div>
    </div>
  </div>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import {getToken} from  '@/api/utils'
import axios from  '@/api/axiosConfig'
import mini_head_top from "@/mini_pages/mini_head_top"
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
export default {
  name : 'mini_qb',
  data() {
    return {
      activeNames:["1"],
      viewQbOneDetail: {
        moduleId :'',
        moduleName:'',
        totalCount : '',
        learnPer : 0,
        learnOkPer : 0,
        learnCount :'',
        learnOkCount : '',
        qtList :[]
      },
      qbView : {
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        id: '',
        learnAnswer :'',
        learnTime :'',
        answerCheckType :'',
        selected : false,
        resultOk: false,
        seeAnswer:false,
        imageUrlList :[]
      },
      
      tokenObj:{

        token :''
      }
    }
  },
  methods : {
   goHome(){
      this.$router.push({path:'/mini_index'})
    },
    funcAnswered(percentage){
      return '已答' + percentage +'%'
    },
    funcOk(percentage){
      return '正确' + percentage +'%'
    },
    seeAnswer(){
      this.qbView.seeAnswer = true
    },

    qbLearnOneModuleSum(id){
      let url = "/bc/exa/qb/qbLearnOneModuleSum"
      let dat0 = { id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.viewQbOneDetail.moduleName = dat.moduleName
          this.viewQbOneDetail.totalCount = dat.totalCount
          this.viewQbOneDetail.learnOkCount = dat.learnOkCount
          this.viewQbOneDetail.learnCount = dat.learnCount
          if(dat.totalCount != 0 ){
            this.viewQbOneDetail.learnOkPer =  Math.floor( 100 *  dat.learnOkCount /  dat.totalCount )
            this.viewQbOneDetail.learnPer = Math.floor( 100 * dat.learnCount / dat.totalCount )
          }
          if(dat.qtList != null && dat.qtList.length != 0){
            dat.qtList.forEach(t=>{
              this.viewQbOneDetail.qtList.push({
                count:t.count,
                learnCount:t.learnCount,
                learnOkCount:t.learnOkCount,
                answerCheckType:t.answerCheckType
              })
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },
    leanNextQb(id,curQbId,asc){
      let url = "/bc/exa/qb/leanNextQb"
      let dat0 = {moduleId:id, curQbId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    recordErrorQb(){
      if( !this.qbView.selected){
        this.$message({
          showClose: true,
          message: '该题目未作答，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }

      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      
      
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    }, 
    recordOneSchedule(){
      let url = "/bc/exa/qb/recordOneSchedule"
      let dat0 = {moduleId:this.viewQbOneDetail.moduleId, qbId:this.qbView.id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入书签成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    leanNextUndoQb(){
      if(!this.qbView.selected) {
        this.$message({
          showClose: true,
          message: '当前题目未作答',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/qb/leanNextUndoQb"
      let dat0 = {id: this.viewQbOneDetail.moduleId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    submitAnswer(){
      if(this.qbView.checkedOptList.length == 0){
        this.$message({
          showClose: true,
          message: '请选择答案！',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let answer = this.qbView.checkedOptList.sort().join("") 
      let url = "/bc/exa/qb/leanCommitAnswerQb"
      let dat0 = { qbId:this.qbView.id, answer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.qbView.selected = true
          this.qbView.learnAnswer = answer
          if(answer == this.qbView.answer ){
            this.qbView.resultOk = true
          }else {
            this.qbView.resultOk = false
          }
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION })
      })
    },
    
    learnNextQb2(asc){
      this.leanNextQb( this.viewQbOneDetail.moduleId, this.qbView.id,asc)
    },
    leanNextQb(id,curQbId,asc){
      let url = "/bc/exa/qb/leanNextQb"
      let dat0 = {moduleId:id, curQbId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    recordOneSchedule(){
      let url = "/bc/exa/qb/recordOneSchedule"
      let dat0 = {moduleId:this.viewQbOneDetail.moduleId, qbId:this.qbView.id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入书签成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    leanNextUndoQb(){
      if(!this.qbView.selected) {
        this.$message({
          showClose: true,
          message: '当前题目未作答',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/qb/leanNextUndoQb"
      let dat0 = {id: this.viewQbOneDetail.moduleId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    // clearViewQbOneDetail(){
    //    this.viewQbOneDetail.learnOkPer = ''
    //    this.viewQbOneDetail.learnPer = ''
    //    this.viewQbOneDetail.moduleId = ''
    //    this.viewQbOneDetail. moduleName = ''
    //    this.viewQbOneDetail.totalCount  = ''
    //    this.viewQbOneDetail.learnCount  = ''
    //    this.viewQbOneDetail.learnOkCount  = ''
    //    this.viewQbOneDetail.qtList.splice(0)
    //    clearViewQbForm()
    // },

    clearViewQbForm(){
      this.dialogVisual.viewQbVisual = false
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.uniqNo = ''
      this.qbView.answerCheckType = ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
      this.qbView.checkedOptList.splice(0)
      this.qbView.learnAnswer = ''
      this.qbView.id = ''
    },

    qmListLoad(pageNo){
      let url = "/bc/exa/qm/qmPage"
      let dat0 = {
          pageSize: 8,
          pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.tableData = [];
            dat.data.forEach(t=>this.tableData.push(t))
            this.pager.totalCount = dat.totalDataCount;
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全知识信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
  },
  created () {
    this.viewQbOneDetail.moduleId = this.$route.query.id
    setTimeout(()=>{this.qbLearnOneModuleSum(this.viewQbOneDetail.moduleId)},200)
    setTimeout(()=>{this.leanNextQb(this.viewQbOneDetail.moduleId,0,true)},200)
  },
  mounted() {
     
  },
  components:{
      mini_head_top
    }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
</style>
    


// WEBPACK FOOTER //
// src/mini_pages/mini_qb.vue